import { render } from "./LandlordsWorkStationComponent.vue?vue&type=template&id=e5f48f84&scoped=true&ts=true"
import script from "./LandlordsWorkStationComponent.vue?vue&type=script&lang=ts"
export * from "./LandlordsWorkStationComponent.vue?vue&type=script&lang=ts"

import "./LandlordsWorkStationComponent.vue?vue&type=style&index=0&id=e5f48f84&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f48f84"]])

export default __exports__